/** Format schedule time from admin (HH:MM or HH:MM:SS) for public display. */
export function formatScheduleTime(timeStr) {
  if (timeStr == null || timeStr === '') return '';
  const raw = String(timeStr).trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return raw;

  const hours = parseInt(match[1], 10);
  const minutes = match[2];
  if (Number.isNaN(hours)) return raw;

  const period = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  return `${hour12}:${minutes} ${period}`;
}

export function formatEventDayDate(dateStr) {
  if (!dateStr) return '';
  const iso = String(dateStr).trim().split(/[T\s]/)[0];
  const d = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}
